import Card from "components/card";
import BarChart from "components/charts/BarChart";
import {
  barChartDataWeeklyRevenue,
  barChartOptionsWeeklyRevenue,
} from "variables/charts";
import { MdBarChart } from "react-icons/md";

const WeeklyRevenue = () => {
  return (
    <Card extra="flex flex-col bg-white w-full rounded-3xl py-6 px-2 text-center">
      <div className="mb-auto flex items-center justify-between px-6">
        <h2 className="text-lg font-bold text-navy-700 dark:text-white">
          Weekly Revenue
        </h2>
        <button className="p-2 bg-lightPrimary rounded-lg hover:bg-gray-100">
          <MdBarChart className="h-6 w-6 text-brand-500" />
        </button>
      </div>

      <div className="h-[250px] w-full xl:h-[350px] mt-4">
        <BarChart
          chartData={barChartDataWeeklyRevenue}
          chartOptions={barChartOptionsWeeklyRevenue}
        />
      </div>

      <div className="flex justify-center gap-4 mt-4">
        {/* GitHub Button */}
        <a href="https://github.com" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-gray-600 p-3 hover:bg-gray-700">
            <img src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/github.svg" alt="GitHub" className="w-6 h-6" />
          </button>
        </a>

        {/* Facebook Button */}
        <a href="https://www.facebook.com/profile.php?id=100094314013209" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-blue-600 p-3 hover:bg-blue-700">
            <img src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg" alt="Facebook" className="w-6 h-6" />
          </button>
        </a>

        {/* WhatsApp Button */}
        <a href="https://wa.me/your-whatsapp-number" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-green-500 p-3 hover:bg-green-600">
            <img src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/whatsapp.svg" alt="WhatsApp" className="w-6 h-6" />
          </button>
        </a>

        {/* Call Button */}
        <a href="tel:your-phone-number">
          <button className="flex items-center justify-center rounded-full bg-gray-600 p-3 hover:bg-gray-700">
            <img src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/phone.svg" alt="Call" className="w-6 h-6" />
          </button>
        </a>

        {/* Telegram Button */}
        <a href="https://t.me/your-telegram-username" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-blue-400 p-3 hover:bg-blue-500">
            <img src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/telegram.svg" alt="Telegram Channel" className="w-6 h-6" />
          </button>
        </a>
      </div>
    </Card>
  );
};

export default WeeklyRevenue;
